import { getAwsEnvironmentConfig } from "@/config/awsEnvironment.js";
import { getMarkedAuthEnvironment } from "@/utils/authStorage.js";

function readUserPoolIdFromToken(session) {
  const iss =
    session?.tokens?.idToken?.payload?.iss ||
    session?.tokens?.accessToken?.payload?.iss;
  if (!iss) return null;
  const parts = String(iss).split("/");
  return parts[parts.length - 1] || null;
}

export function sessionHasTokens(session) {
  return Boolean(session?.tokens?.accessToken && session?.tokens?.idToken);
}

export function sessionMatchesEnvironment(
  session,
  config = getAwsEnvironmentConfig(),
) {
  if (!sessionHasTokens(session)) return false;

  const tokenPoolId = readUserPoolIdFromToken(session);
  if (!tokenPoolId || tokenPoolId !== config.userPoolId) {
    return false;
  }

  const markedEnvironment = getMarkedAuthEnvironment();
  if (markedEnvironment && markedEnvironment !== config.environment) {
    return false;
  }

  return true;
}

export function readEmailFromSession(session) {
  const payload = session?.tokens?.idToken?.payload;
  const email = payload?.email || payload?.["cognito:username"];
  return email ? String(email).trim().toLowerCase() : "";
}
